module.exports = "/build/web/svg/pec-power.b8a323e1bcd84efbc927e70f7dda5405.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/pec-power.svg
// module id = 175
// module chunks = 24